import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LanguageService } from '@mzic/mzic-services';

export const languageGuard: CanActivateFn = () => {
  const router = inject(Router);
  const languageService = inject(LanguageService);
  const browserLang = languageService.getBrowserLanguage();

  if (browserLang.startsWith('pt')) {
    router.navigate(['/pt-br/home']);
  } else {
    router.navigate(['/en/home']);
  }

  // Retorna false porque o redirecionamento já ocorreu
  return false;
};
